import React, { Suspense } from 'react'
import tw, { styled } from 'twin.macro'
import { motion, AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { ProgressBar } from 'baseui/progress-bar'
import { pathOr } from 'ramda'
import { Spinner } from '@/components/Spinner'
import { Button, Progress } from '@chakra-ui/react'

import {ATTRIBUTE_LIST, AttributeEnum} from '@/types/nftAttribute'
import { claimSpiritMachineAtom } from '@/features/spirit/atoms/claimSpiritMachineAtom'
import { UpdateSpiritButton } from '@/features/spirit/components/buttons'
import { claimSpiritStageAnimateAtom, claimSpiritStageAtom, ClaimSpiritStageEnum } from './atoms/claimSpiritStageAtom'
import { spiritAtom } from '@/features/spirit/atoms/spiritAtom'

// SripitsRight
export const Right = styled(motion.div)`
  position: absolute;
  height: 100%;
`

export const RightLineImg = styled.img`
  width: 12.76vw;
  max-width: 12.76vw;
  height: auto;
  position: absolute;
  top: 51vh;
  left: 59.5vw;
`

// PersonalData
const PersonalDataWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-40%);
  left: 74vw;
`

export const Title = styled.div`
  ${tw`font-secondary`}
  font-size: 1.04vw;
  color: #ffffff;
`

export const ProgressContainer = styled.div`
`

export const DataBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const DataName = styled.span`
  ${tw`font-secondary`}
  font-size: 0.73vw;
  color: #ffffff;
`
export const DataValue = styled.span`
  ${tw`font-primary`}
  font-size: 0.73vw;
  color: #ffffff;
`

// SripitsRight: original status
export const TextWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 77.5vw;
  width: 11.98vw;
  /* width: 230px; */
`
export const RightLineGrayImg = styled.img`
  width: 16.88vw;
  max-width: 16.88vw;
  height: auto;
  position: absolute;
  top: 51vh;
  left: 59.5vw;
`
export const TextMedium = styled.div`
  ${tw`font-primary`}
  font-size: 1.04vw;
  color: #ffffff;
  line-height: 3.03vh;
`

export const TextSmall = styled.div`
  ${tw`font-primary`}
  font-size: 0.833vw;
  color: #ffffff;
  line-height: 2.32vh;
  margin-top: 4.04vh;
`

const Placeholder = () => {
  return (
    <TextWrapper>
      <TextMedium>
        <strong style={{color: '#27FFE2'}}>{`Equip `}</strong>
        your Shell to Spirit
      </TextMedium>
      <TextSmall>
        Activate the full character and enter into PhalaWorld
      </TextSmall>
    </TextWrapper>
  )
}

const LoadingBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  ${tw`font-primary`}
`

const PersonalDataPanel: React.FC = () => {
  const spirit = useAtomValue(spiritAtom)
  const machine = useAtomValue(claimSpiritMachineAtom)
  return (
    <PersonalDataWrapper>
      <Title>Personal Attributes</Title>
      <div tw="w-[15.25vw] flex flex-col gap-5 my-5">
        <div tw="flex flex-col gap-2.5">
          <DataBar>
            <DataName>Dexterity</DataName>
            <DataValue>{spirit.dexterity.level}</DataValue>
          </DataBar>
          <div tw="bg-gray-600 rounded-sm">
            <Progress size="sm" value={spirit.dexterity.progress} />
          </div>
        </div>
        <div tw="flex flex-col gap-2.5">
          <DataBar>
            <DataName>Willpower</DataName>
            <DataValue>{spirit.willpower.level}</DataValue>
          </DataBar>
          <div tw="bg-gray-600 rounded-sm">
            <Progress size="sm" value={spirit.willpower.progress} />
          </div>
        </div>
        <div tw="flex flex-col gap-2.5">
          <DataBar>
            <DataName>Intelligence</DataName>
            <DataValue>{spirit.intelligent.level}</DataValue>
          </DataBar>
          <div tw="bg-gray-600 rounded-sm">
            <Progress size="sm" value={spirit.intelligent.progress} />
          </div>
        </div>
        <div tw="flex flex-col gap-2.5">
          <DataBar>
            <DataName>Strength</DataName>
            <DataValue>{spirit.strength.level}</DataValue>
          </DataBar>
          <div tw="bg-gray-600 rounded-sm">
            <Progress size="sm" value={spirit.strength.progress} />
          </div>
        </div>
      </div>
      {machine.matches('signedIn.updatingSpirit') && (
        <LoadingBox>
          <Spinner />
        </LoadingBox>
      )}
      {(machine.context.spiritCollection?.length > 0) && (
        <Suspense fallback={<Button isLoading disabled>Update Spirit</Button>}>
          <UpdateSpiritButton />
        </Suspense>
      )}
    </PersonalDataWrapper>
  )
}

const SpiritsRight: React.FC = () => {
  const stage = useAtomValue(claimSpiritStageAtom)
  const variants = useAtomValue(claimSpiritStageAnimateAtom)
  return (
    <AnimatePresence mode="wait">
      <Right
        initial="initial"
        animate="animate"
        exit="exit"
        variants={variants.rightSection}
      >
        <RightLineImg
          src="/static/images/indexPage/Spirit/step02_img_line_right_normal.png"
          alt="line_right_normal"
        />
        {(stage === ClaimSpiritStageEnum.claimed || stage === ClaimSpiritStageEnum.injected) ? (
          <Suspense fallback={<Placeholder />}>
            <PersonalDataPanel />
          </Suspense>
        ) : (
          <Placeholder />
        )}
      </Right>
    </AnimatePresence>
  )
}

export default SpiritsRight
